import { ACTIVITY_ACTION_TYPES, EVIDENCE_TAGGING_ACTION_TYPES, READING_ACTION_TYPES } from '../actions/action_types';

export const initialState = {
  answers: [],
  currentActivityId: null,
  selectedWrongInferenceIds: [],
  selectedWrongEvidenceIds: [],
  selectedInferenceId: 0,
  selectedEvidenceId: 0,
  selectedEvidenceText: '',
  correctEvidenceId: [],
  correctEvidenceText: '',
  allEvidenceActivities: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIVITY_ACTION_TYPES.SET_ACTIVITIES:
      return {
        ...state,
        allEvidenceActivities: payload.filter(activity => activity.activityType === 'tagEvidence'),
      };

    case EVIDENCE_TAGGING_ACTION_TYPES.SELECT_INFERENCE:
      return {
        ...state,
        selectedInferenceId: payload.selectedInferenceId,
        selectedEvidenceId: 0,
      };

    case EVIDENCE_TAGGING_ACTION_TYPES.SELECT_EVIDENCE:
      return {
        ...state,
        selectedEvidenceId: payload.selectedEvidenceId,
        selectedEvidenceText: payload.selectedEvidenceText,
      };

    case EVIDENCE_TAGGING_ACTION_TYPES.ANSWER: {
      const { answerChosen, isCorrectInference, isCorrectEvidence } = payload;
      const answers = [...state.answers, answerChosen];
      const alreadySelectedWrongInferenceIds = !isCorrectInference
        ? [...state.selectedWrongInferenceIds, answerChosen.inferenceId]
        : state.selectedWrongInferenceIds;
      const alreadySelectedWrongEvidenceIds = !isCorrectEvidence
        ? [...state.selectedWrongEvidenceIds, answerChosen.evidenceId]
        : state.selectedWrongEvidenceIds;
      return {
        ...state,
        selectedWrongInferenceIds: alreadySelectedWrongInferenceIds,
        selectedWrongEvidenceIds: alreadySelectedWrongEvidenceIds,
        answers,
      };
    }

    case EVIDENCE_TAGGING_ACTION_TYPES.UNTAG_EVIDENCE:
      return {
        ...state,
        selectedEvidenceId: 0,
        selectedEvidenceText: '',
      };

    case EVIDENCE_TAGGING_ACTION_TYPES.CLEAR_EVIDENCE_TAGGING_ANSWER:
      return {
        ...state,
        selectedEvidenceId: 0,
        selectedEvidenceText: '',
        selectedInferenceId: 0,
      };

    case EVIDENCE_TAGGING_ACTION_TYPES.CLEAR_EVIDENCE_TAGGING_EVIDENCE:
      return {
        ...state,
        selectedEvidenceId: 0,
        selectedEvidenceText: '',
      };

    case ACTIVITY_ACTION_TYPES.SET_CURRENT_ACTIVITY: {
      const { currentActivityId, allEvidenceActivities } = state;
      const newCurrentActivityId = payload.activityId;

      if (newCurrentActivityId && currentActivityId !== newCurrentActivityId) {
        const currentActivity = allEvidenceActivities.find(activity => activity.activityId === newCurrentActivityId);

        if (currentActivity) {
          return {
            ...state,
            currentActivityId: currentActivity.activityId,
            selectedWrongInferenceIds: currentActivity.selectedWrongInferenceIds || [],
            selectedWrongEvidenceIds: currentActivity.selectedWrongEvidenceIds || [],
          };
        }
      }

      return { ...initialState, allEvidenceActivities };
    }

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default:
      return state;
  }
};
